document.addEventListener("DOMContentLoaded", () => {
  const accordionItems = document.querySelectorAll(".accordion__tabset-item");

  if (!accordionItems.length) return;

  accordionItems.forEach((item) => {
    const button = item.querySelector(".accordion__tabset-link");
    const content = item.querySelector(".accordion__tabset-content");

    if (!button || !content) return;

    button.addEventListener("click", (e) => {
      e.preventDefault();
      const isOpen = content.style.maxHeight;
      //hide all open contents
      accordionItems.forEach((i) => {
        const content = i.querySelector(".accordion__tabset-content");
        const button = i.querySelector(".accordion__tabset-link");
        if (!button || !content) return;
        content.style.maxHeight = null;
        button.classList.remove("active");
      });

      if (isOpen) {
        content.style.maxHeight = null;
        button.classList.remove("active");
      } else {
        button.classList.add("active");
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
});
